import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const householdModule = {
  state: {
    // 某社區的戶別列表
    householdList: [],
    // 特定戶別編號的住戶列表
    residentList: []
  },
  actions: {
    // 取得某社區的戶別列表
    async getHouseholdList({ commit, rootState }) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      console.log('currentCommunityId: ', currentCommunityId)

      try {
        const res = await baseFetch(
          API.getHouseholdList.url(currentCommunityId),
          API.getHouseholdList.method
        )
        if (!res.isError && res.data) {
          commit('SET_HOUSEHOLD_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 根據戶別編號取得住戶列表
    async getResidentList({ commit }, householdId) {
      try {
        const res = await baseFetch(
          API.getResidentList.url(householdId),
          API.getResidentList.method
        )
        if (!res.isError && res.data) {
          commit('SET_RESIDENT_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 匯入住戶
    importhouseholdList({ rootState }, payload) {
      // console.log(payload)
      const currentCommunityId = rootState.commonModule.currentCommunityId

      const { file } = payload
      let formData = new FormData()
  		formData.append('file', file)

      // 回到頁面處理
      return baseFetch(
        API.importhouseholdList.url(currentCommunityId),
        API.importhouseholdList.method,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
    }
  },
  mutations: {
    // 儲存社區列表
    SET_HOUSEHOLD_LIST(state, payload) {
      state.householdList = payload
    },
    // 儲存特定的戶別的住戶列表
    SET_RESIDENT_LIST(state, payload) {
      state.residentList = payload
    }
  },
  getters: {
    getHouseholdList: (state) => state.householdList,
    getResidentList: (state) => state.residentList
  },
  namespaced: true
}

export default householdModule
